// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"QY-z","subtitle":"RY-z","wrapper":"SY-z","leftArrow":"TY-z","rightArrow":"UY-z"};